import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightForwarder/landing/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

type SectionAboutProps = {
  country: string;
};

const SectionAbout = ({ country }: SectionAboutProps): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>
        <div className={cn('about__overlay')}>
          <div className={cn('about__content')}>
            <h3 className={cn('about__heading')}>
              Freight Forwarding Business and Tax Registration in {country}
            </h3>
            <p className={cn('about__paragraph')}>
              Begin your venture by officially registering your business entity in {country}.
              This registration process involves obtaining a unique company identification number,
              which you will use in all official documents and transactions. Additionally, register
              with the relevant tax authorities to enable you to conduct business within the legal
              frameworks of {country}.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAbout;
